export const uriEncodeSearchParams = (baseUrl, paramsObject) => {
  return Object.keys(paramsObject).reduce((acc, key, idx) => {
    if (!key || !paramsObject[key]) return acc
    return `${acc}${idx === 0 ? '?' : '&'}${key}=${encodeURIComponent(
      paramsObject[key]
    )}`
  }, baseUrl)
}
